import * as React from "react";
import { Modal } from "@grandvisionhq/common";
import { H3, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { seedFieldState } from "../../../../../../../../StepShipping/mappers/StepShipping/mappers/seed-shipping-form.js";
import { formStatesToValues } from "../../../../../../../utils/LoginExpressCheckout/utils/form-state-to-values.js";
import { isFormDataValid } from "../../../../../../../utils/LoginExpressCheckout/utils/validate-form-data.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
import { useFormSlotWithoutRedux } from "../../../../../../../../slots/forms/slots/forms/form-context.js";
import { useBaseSummarySlot } from "../../../../../../../../slots/summaries/slots/summaries/summary-context.js";
const CompanySummary = ({ companyDetails, onSubmit, isOrderDetailsValid }) => {
  const { getLabel } = useIntl();
  const { formFieldsMap } = useCheckoutSettings();
  const filledFormData = companyDetails && Object.entries(companyDetails).reduce(
    (item, [key, value]) => ({ ...item, [key]: seedFieldState(key, value) }),
    {}
  );
  const [companyDetailsState, setCompanyDetailsState] = React.useState();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const handleSubmit = React.useCallback(
    (companyFormState) => {
      const updatedCompanyDetails = companyDetailsState && formStatesToValues(companyFormState.formState);
      updatedCompanyDetails && onSubmit?.({ company: updatedCompanyDetails });
      setIsModalOpen(false);
    },
    [companyDetailsState, onSubmit]
  );
  const { company: companyForm } = useFormSlotWithoutRedux({
    formInitialData: filledFormData ? { company: filledFormData } : {},
    onChange: setCompanyDetailsState,
    onSubmit: handleSubmit,
    onCancel: () => setIsModalOpen(false),
    className: "login-express-checkout__form-modal__form login-express-checkout__form-modal__form--with-custom-height"
  });
  const isCompanyDetailsFormComplete = React.useMemo(() => {
    return formFieldsMap?.company ? isFormDataValid(formFieldsMap?.company, companyDetails) ?? false : false;
  }, [companyDetails, formFieldsMap?.company]);
  const labels = {
    title: getLabel("checkout.customerType.company"),
    save: getLabel("common.actions.save")
  };
  const { Slots } = useBaseSummarySlot();
  if (!Slots.company) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Modal,
    {
      className: "login-express-checkout__form-modal",
      isOpen: isModalOpen,
      onModalClose: () => setIsModalOpen(false),
      showIcon: true
    },
    /* @__PURE__ */ React.createElement(H3, { variant: "body-head" }, labels.title),
    /* @__PURE__ */ React.createElement(React.Fragment, null, companyForm)
  ), /* @__PURE__ */ React.createElement(
    Slots.company,
    {
      actions: { onEdit: () => setIsModalOpen(true) },
      values: companyDetails,
      errorNotification: !isCompanyDetailsFormComplete ? /* @__PURE__ */ React.createElement(
        Alert,
        {
          role: isOrderDetailsValid ? "status" : "alert",
          className: "alert-m-default ",
          variant: isOrderDetailsValid ? "info" : "error",
          title: getLabel("checkout.company.incomplete.title")
        },
        getLabel("checkout.information.incomplete.message")
      ) : null
    }
  ));
};
export {
  CompanySummary
};
//# sourceMappingURL=CompanySummary.js.map
